import React from 'react'
import './Footer.css'

function Footer() {



  return (
    
        <footer className="footer pt-3 pb-5 text-center">
   Copy right &copy; 2022 Electro Magnet - Developed by Jasir
  </footer>
  
    
  )
}

export default Footer